import * as React from 'react'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { LogIn } from 'react-feather'
import { t } from 'i18next'
import { useTheme } from '@mui/material/styles'
import { appNameStyles, footerStyles } from './OnboardingLayout.styles'

type OnboardingLayoutProps = {
	children: React.ReactNode
	navigateLogin: () => void
}
export default function OnboardingLayout({ children, navigateLogin }: OnboardingLayoutProps) {
	const { palette } = useTheme()
	return (
		<Stack sx={{ height: '100vh' }}>
			<Box sx={{ display: 'flex', alignItems: 'center', padding: '30px' }}>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={`${process.env.PUBLIC_URL}/assets/images/new_prop_p.svg`}
						alt="Logo"
						style={{ maxWidth: '100%', height: '25px' }}
					/>
					<Typography component="h1" sx={appNameStyles}>
						{t('prop_ai')}
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', margin: '0 0 0 auto', color: palette.text.darkBlue }}>
					<Button variant="text" onClick={navigateLogin}>
						<LogIn />
						<Typography marginLeft="8px" fontSize="14px" fontWeight="bold">
							{t('onboarding.layout.sign_in_button_label')}
						</Typography>
					</Button>
				</Box>
			</Box>
			<Grid container sx={{ marginBottom: 'auto', flexGrow: 1, alignItems: 'center' }}>
				<Grid item xs={1} />
				<Grid item xs={10}>
					{children}
				</Grid>
				<Grid item xs={1} />
			</Grid>
			<Box sx={footerStyles(palette)}>
				<Typography alignContent="center">{t('onboarding.layout.contact_us_link_label')}</Typography>
				<Typography alignContent="center">{t('onboarding.layout.privacy_and_terms_link_label')}</Typography>
				<Typography alignContent="center">{t('onboarding.layout.trademark_link_label')}</Typography>
			</Box>
		</Stack>
	)
}
